import { ChatSession } from '../../../domain/chat/models/ChatSession';

export interface ChatSessionsState {
    byId: Record<string, ChatSession>;
    allIds: string[];
}

export const initialChatSessionsState: ChatSessionsState = {
    byId: {},
    allIds: [],
};
